import { render, staticRenderFns } from "./ReportFrame.vue?vue&type=template&id=2ebab668&scoped=true&"
import script from "./ReportFrame.vue?vue&type=script&lang=js&"
export * from "./ReportFrame.vue?vue&type=script&lang=js&"
import style0 from "./ReportFrame.vue?vue&type=style&index=0&id=2ebab668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebab668",
  null
  
)

export default component.exports